/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Tamara
 * @author      Beshoy Samuel <info@scandiweb.com>
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './TamaraPdp.style';

/** @namespace Scandipwa/Component/TamaraPdp/Component */
export class TamaraPdpComponent extends PureComponent {
    static propTypes = {
        formatedPrice: PropTypes.number,
        order: PropTypes.number,
        error: PropTypes.string,
        isLoading: PropTypes.bool
    };

    static defaultProps = {
        formatedPrice: null,
        order: 0,
        error: null,
        isLoading: true
    };

    componentDidUpdate(prevProps) {
        const { prevFormatedPrice } = prevProps;
        const { formatedPrice } = this.props;

        if (prevFormatedPrice !== formatedPrice && window.TamaraWidgetV2) {
            window.TamaraWidgetV2.refresh();
        }
    }

    render() {
        const {
            formatedPrice, error, isLoading, order
        } = this.props;

        if (isLoading || !formatedPrice || error) {
            return null;
        }

        return (
            <div style={ { order } }>
                <tamara-widget amount={ formatedPrice } type="tamara-summary" inline-type="2" />
            </div>
        );
    }
}

export default TamaraPdpComponent;
